import { render } from "./BatchStockTable.vue?vue&type=template&id=1dc966ce"
import script from "./BatchStockTable.vue?vue&type=script&lang=js"
export * from "./BatchStockTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__